module.exports = __webpack_public_path__ + "img/video11.eca74a5c.jpg";